import script from "./authorizeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./authorizeModal.vue?vue&type=script&setup=true&lang=js"

import "./authorizeModal.vue?vue&type=style&index=0&id=4474feca&scoped=true&lang=css"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4474feca"]])

export default __exports__